import { css } from '@linaria/core';

export const defaulTooltipStyles = css`
  padding: 20px;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;

  font-family: var(--oc-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: var(--oc-text-body);

  opacity: 0;
  transform-origin: top center;
  transform: translate3d(0, 20px, 0);
  transition:
    opacity 250ms ease-in-out,
    transform 250ms ease-in-out;
  [data-enter] & {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  /* z-index needs to be 102 to make sure it appears over the top of the side banners*/
  z-index: var(--cxy-z-index-above-ad);
`;
